import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';

import { ComplexMapFieldValue, FieldReadHelper } from '@stylehaven/components';
import { MHSearchRoutingService } from '../../../../common/services/common/search-routing.service';
import {
    WebserviceConfig,
    WebserviceConfigJson
} from '../../../../external-webservice/entities/webservice-config.entity';
import { ComplexListReadonlyFieldComponent } from '../complex-list-readonly-field/complex-list-readonly-field.component';

@Component({
    standalone: false,
    selector: 'med-webservice-list-readonly-field',
    templateUrl: './webservice-list-readonly-field.component.html',
    styleUrls: ['../readonly-base-style.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class WebserviceListReadonlyFieldComponent extends ComplexListReadonlyFieldComponent {
    private webserviceConfig: WebserviceConfig;

    constructor(
        protected fieldHelper: FieldReadHelper,
        protected searchRoutingService: MHSearchRoutingService,
        @Inject('config') private readonly config: WebserviceConfigJson
    ) {
        super(fieldHelper, searchRoutingService);
        this.webserviceConfig = new WebserviceConfig(config);
    }

    getWebserviceValue(value: ComplexMapFieldValue): string {
        return this.webserviceConfig.getWebserviceDataLabel(
            value,
            this.translateService.translate('complex.label-not-found')
        );
    }
}
